import React, { useState } from 'react';
import AppLoading from '../components/AppLoading';
import { PagesCommonProps } from '../helpers/pagesUtil';
import TableGraph from '../components/Charts/comps/TableGraph';
import { mostAndLeastUsersOtherActions } from '../helpers/page2';
import { showUserNamesOnRowSelect, selectedDataRowForTableDefaultState } from '../helpers/page1';
import SummaryCardContainer from '../components/SummaryCardsContainer';
import { mergeChartConfigWithApiData } from "../helpers/chartConfigHelper";
import { dashboardGraphsOptions, GOOGLE_CHARTS_TYPES } from '../consts/graphs';
import ChartContainer, { ChartContainerProps } from '../components/Charts/ChartContainer';
import useFetchDashboard2Data from '../hooks/fetchDataComponents/useFetchDashboard2Data';

const { AREACHART, TABLE, COLUMNCHART } = GOOGLE_CHARTS_TYPES;

const Page2DashboardGraphs: React.FC<PagesCommonProps> = ({ filters, graphs = [] }) => {
  const [hoveredRowStye, setHoveredRowStye] = useState<{ top?: number, left?: number, width?: string } | null>(null);
  const [selectedDataRowForTable, setSelectedDataRowForTable] = useState(selectedDataRowForTableDefaultState);

  const {
    data,
    onScroll,
    isLoadingMap,
    endpointsMap,
    onSortChange,
    otherActions,
    exportActions,
  } = useFetchDashboard2Data({ filters, graphs });
  
  if (isLoadingMap?.fetchSummaryCardsData) return <AppLoading />;

  const baseChartsConfig: ChartContainerProps[] = [
    {
      onScroll,
      boxWidth: "95%",
      chartType: AREACHART,
      title: 'Users Compliance Trend',
      chartId: "fetchUsersComplianceTrendData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
        data?.fetchUsersComplianceTrendData?.data?.[0],
        { v: "% of Completed Courses" }
      ),
    },
    {
      onScroll,
      boxWidth: "95%",
      chartType: COLUMNCHART,
      title: "Monthly Active Users",
      chartId: "fetchMonthlyActiveUsersData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
        data?.fetchMonthlyActiveUsersData?.data?.[0],
        { v: "Active Users", h: " " }
      ),
      onRowSelect: (param: any) => showUserNamesOnRowSelect(
        "fetchMonthlyActiveUsersData",
        param,
        data?.fetchMonthlyActiveUsersData as any,
        setHoveredRowStye,
        setSelectedDataRowForTable,
      ),
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "65%",
      chartType: TABLE,
      title: 'Users by Course & Completion (%)',
      chartId: "fetchUsersByCourseAndCompletionData",
      options: dashboardGraphsOptions.TableChartOptions,
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "30%",
      chartType: TABLE,
      title: 'Most / Least Compliant Users',
      chartId: "fetchMostLeastCompliantUsersData",
      options: dashboardGraphsOptions.TableChartOptions,
      otherActions: mostAndLeastUsersOtherActions("fetchMostLeastCompliantUsersData", otherActions, data),
    },
  ];

  const ChartsListData: ChartContainerProps[] = mergeChartConfigWithApiData(baseChartsConfig, graphs);

  return (
    <>
      <SummaryCardContainer summaryCardsData={data?.fetchSummaryCardsData?.data as any} />
      <div className="charts-container">
        {ChartsListData.map((props, idx) => {
          const chartId = props.chartId;
          if (!chartId) return null;
          return (
            <ChartContainer 
              {...props} 
              key={idx} 
              index={idx}
              queryParams={filters}
              exportActions={exportActions}
              data={data?.[chartId as keyof typeof data]?.data}
              total={data?.[chartId as keyof typeof data]?.total}
              endpoint={endpointsMap?.[chartId as keyof typeof endpointsMap]}
              isLoading={isLoadingMap?.[chartId as keyof typeof isLoadingMap]}
            />
          );
        })}
      </div>
      {hoveredRowStye !== null && (
        <div className="chart-hovered" style={hoveredRowStye}>
          <div className="headings">
            <strong>Active Users</strong>
          </div>
          <div style={{ width: hoveredRowStye.width || "220px", height: "240px", color: "black" }}>
            <TableGraph data={selectedDataRowForTable} isFullHeight />
          </div>
        </div>
      )}
    </>
  );
};

export default Page2DashboardGraphs;
